function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-users-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9a9,9,0,1,1,9,9A9,9,0,0,1,0,9Zm2.63,4.57a7.84,7.84,0,0,0,12.74,0,2.4,2.4,0,0,0-1.8-2l-1.17-.29a5.23,5.23,0,0,1-6.8,0l-1.17.29A2.4,2.4,0,0,0,2.63,13.57ZM4.94,7.26A4.06,4.06,0,1,0,9,3.19,4.06,4.06,0,0,0,4.94,7.26Z",
    style: {
      fill: "#3fa9f5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsersActive);
export default __webpack_public_path__ + "static/media/icon-users-active.5ef58c7b9addb0bbf03d4d228db1cce2.svg";
export { ForwardRef as ReactComponent };